let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6n4fN")).then(() => parcelRequire('7lfvw'));